/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Other_Past_2Inputs */



/**
* | output |
* | --- |
* | "ran a tool" |
*
* @param {Chat_Summary_Other_Past_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_other_past_2 = /** @type {((inputs?: Chat_Summary_Other_Past_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Other_Past_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("ein Tool ausgeführt")
	return /** @type {LocalizedString} */ ("ran a tool")
});